import PropTypes from "prop-types";
import React from 'react';
import { page as pageIndex } from "../../../globals";
import STSComponent from "../../STSComponent/STSComponent";
import "./css/MultiSelect.scss";
import CustomDropdown from "./CustomDropdown";

class MultiSelect extends STSComponent {
  constructor(props) {
    super(props);
    this.state = {
      isExpanded: false,
      btnHeight: null,
    };
    this.changeBtn = this.changeBtn.bind(this);
  }

  componentDidUpdate() {
    if (this.state.btnHeight !== this.returnBtn()) {
      this.setBtnHeight();
    }
  }

  setBtnHeight = () => {
    this.setState({
      btnHeight: this.returnBtn(),
    });
  };

  renderStatesBoxes = () => {
    const {
      fieldData,
      values,
      updateData,
      location,
      childrenClassName,
      defaultSelectionText,
    } = this.props;
    if (values.selected.length === 0) {
      if (defaultSelectionText) {
        return (
          <div className="states-boxes-item">
            <span className="states-boxes full-name">
              {defaultSelectionText}
            </span>
          </div>
        );
      }
      return null;
    }
    return fieldData.map((item, i) => {
      if (values.selected.includes(item.id)) {
        switch (item.type) {
          case "checkbox":
            return (
              <MultiSelectSmallBox
                key={i}
                itemData={item}
                boxesClass={childrenClassName}
                updateData={updateData}
                location={location}
                values={values}
              />
            );
          case "ch_with_child":
            return (
              <MultiSelectSmallBox
                key={i}
                itemData={item}
                boxesClass={childrenClassName}
                updateData={updateData}
                location={location}
                values={values}
              />
            );
        }
      } else if (item.locality) {
        return item.locality.map((elem, i) => {
          if (values.selected.includes(elem.id)) {
            return (
              <MultiSelectSmallBox
                key={i}
                itemData={elem}
                boxesClass={childrenClassName}
                updateData={updateData}
                location={location}
                values={values}
              />
            );
          }
        });
      }
    });
  };

  changeBtn = () => {
    this.setState({ isExpanded: !this.state.isExpanded });
  };

  returnBtn = () => {
    const el = document.querySelector(".states-btn .local-states");
    return el ? el.scrollHeight : null;
  };

  render() {
    const {
      values,
      fieldData,
      location,
      inputPlaceholder,
      hideBoxes,
      uncheckAll,
      updateData,
    } = this.props;
    const isExpanded = this.state.isExpanded;
    const classNameBoxes = hideBoxes
      ? "states-boxes-container d-none"
      : location.page === pageIndex.local
      ? `states-boxes-container local-states ${
          !isExpanded ? "" : "local-states-expanded"
        } custom-scroll`
      : "states-boxes-container";
    const btn = this.state.btnHeight;
    return (
      <div className="multiselect-field">
        <CustomDropdown
          values={values}
          fieldData={fieldData}
          location={location}
          inputPlaceholder={inputPlaceholder}
          uncheckAll={uncheckAll}
          updateData={updateData}
        />
        <ul className={classNameBoxes}>{this.renderStatesBoxes()}</ul>
        {btn > 324 ? ( // magic number 324 means min height of element in DOM
          <div className="expand-btn" onClick={this.changeBtn}>
            Click here to {!this.state.isExpanded ? "expand" : "collapse"}
          </div>
        ) : null}
      </div>
    );
  }
  static propTypes = {
    values: PropTypes.object.isRequired,
    fieldData: PropTypes.array.isRequired,
    location: PropTypes.object.isRequired,
    inputPlaceholder: PropTypes.string,
    childrenClassName: PropTypes.string,
    defaultSelectionText: PropTypes.string,
    updateData: PropTypes.func,
    uncheckAll: PropTypes.number,
    hideBoxes: PropTypes.bool,
  };
}

export default MultiSelect;

class MultiSelectSmallBox extends STSComponent {
  constructor(props) {
    super(props);
    this.deleteBox = this.deleteBox.bind(this);
  }

  deleteBox() {
    const { location, itemData, updateData } = this.props;
    updateData(location, "ch_uncheck", itemData.id);
  }

  render() {
    const { itemData, boxesClass } = this.props;
    return (
      <div className="states-boxes-item">
        <span className={`states-boxes ${boxesClass}`}>
          {itemData.shortcut}
        </span>
        <div className="states-boxes--xbtnwrap">
          <span className="states-boxes--xbtn" onClick={this.deleteBox} />
        </div>
      </div>
    );
  }

  static propTypes = {
    itemData: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    updateData: PropTypes.func,
    boxesClass: PropTypes.string,
  };
}



// WEBPACK FOOTER //
// ./src/components/FormComponents/MultiSelect/MultiSelect.js